module.exports = __webpack_public_path__ + "img/truck-pin-sim.79f270f2.png";